import React from 'react';
const PlpIntroBreadcrumb = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "intro-plp__breadcrumbs", id: "pd-breadcrumbs" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("nav", { className: "breadcrumb listing", "aria-label": "Breadcrumb" },
                        React.createElement("ol", null, props.breadcrumbs.map((breadcrumb, i) => {
                            return (React.createElement("li", { key: i }, breadcrumb.current ? (React.createElement("span", { className: "breadcrumb__item" }, breadcrumb.title)) : (React.createElement("a", { href: breadcrumb.link, className: "breadcrumb__item" },
                                React.createElement("span", null, breadcrumb.title)))));
                        }))))))));
};
export default PlpIntroBreadcrumb;
